module.exports = __webpack_public_path__ + "static/images/containers/Challenges/components/Challenge/images/sparkles-bottom-conscription.bf283b86.png";


//////////////////
// WEBPACK FOOTER
// ./containers/Challenges/components/Challenge/images/sparkles-bottom-conscription.png
// module id = 2844
// module chunks = 11